import { StatusPill } from '@/components/StatusPill/StatusPill';
import type { JobStatus } from '../schemas';

const LABEL: Record<JobStatus, string> = {
  running: 'running',
  awaiting_input: 'needs input',
  completed: 'done',
  failed: 'failed',
  cancelled: 'cancelled',
};

const VARIANT: Record<JobStatus, 'info' | 'success' | 'danger' | 'muted' | 'warning'> = {
  running: 'info',
  awaiting_input: 'warning',
  completed: 'success',
  failed: 'danger',
  cancelled: 'muted',
};

export function JobStatusBadge({ status }: { status: JobStatus }) {
  return (
    <StatusPill variant={VARIANT[status]} dot={status === 'running'}>
      {LABEL[status]}
    </StatusPill>
  );
}
